import { Image } from '@chakra-ui/image';
import {
    Flex, HStack, Text, VStack
} from '@chakra-ui/layout';
import { t } from '@lingui/macro';
import React, { useState } from 'react';
import {
    useDispatch, useSelector
} from 'react-redux';

import { useSelectorPromoVideoUrl } from '../../../../../../../configuration';
import { AppState } from '../../../../../../app.types';
import { closeModal } from '../../../../../modal-manager';
import { VideoPlayer } from '../../../../../video-player/video-player';
import Line from '../../assets/Line.svg';
import VideoModalBgImage from '../../assets/promoVideoBg.png';
import { PromoVideoPopup } from '../../promo-video-popup-modal';
import { PopoverModalWrapper } from './assign-review-promo-video.styled';

export function PromoVideoPopupModal () {
    const dispatch = useDispatch();
    const cultureCode = useSelector<AppState, string>(state => state.userProfiles.data?.country?.cultureCode || 'en-AU');
    const promoVideoUrl = useSelectorPromoVideoUrl();
    const [showVideo, setShowVideo] = useState(false);
    const videoSrc = promoVideoUrl[cultureCode] || promoVideoUrl['fallback'];

    return (
        <PopoverModalWrapper>
            <VStack
                spacing={0}
                align={'center'}
                textAlign={'center'}
                h={'602px'}
                w={'993px'}
                mb={0}
            >
                {showVideo ?
                    <VideoPlayer
                        onClose={() => dispatch(closeModal())}
                        src={videoSrc}
                        title={'promo video'}
                    /> :
                    <PromoVideoPopup onClick={() => setShowVideo(true)}>
                        <VStack
                            h={'100%'}
                            w={'1030px'}
                            spacing={0}
                            align={'center'}
                            justifyContent={'center'}
                            backgroundImage={VideoModalBgImage}
                            backgroundSize={'cover'}
                            backgroundRepeat={'no-repeat'}
                        >
                            <VStack
                                mt={'-310px'}
                                flexDirection={'column'}
                                gap={'0'}
                            >
                                <HStack justifyContent={'center'}>
                                    <Image src={Line} alt={'line'} w={'64px'} h={'2px'} />
                                    <Flex
                                        fontWeight={'400'}
                                        fontSize={'24px !important'}
                                        lineHeight={'38.5px'}
                                        letterSpacing={'-0.5px'}
                                        color={'#001937'}
                                        width={'161px'}
                                        justifyContent={'center'}
                                    >
                                        {t`video.Modal.Title`}
                                    </Flex>
                                    <Image src={Line} alt={'line'} w={'64px'} h={'2px'} />
                                </HStack>
                                <Text
                                    color={'#001937'}
                                    fontWeight={'400'}
                                    fontSize={'52px !important'}
                                    lineHeight={'57.2px'}
                                    letterSpacing={'-2.2px'}
                                    mb={'7px'}
                                >
                                    {t`video.Modal.HeadingText`}
                                </Text>
                                <Text
                                    fontWeight={'400'}
                                    fontSize={'20px !important'}
                                    lineHeight={'32px'}
                                    letterSpacing={'-0.5px'}
                                    color={'#001937'}
                                >
                                    {t`video.Modal.InfoText1`}
                                    <br />
                                    {t`video.Modal.InfoText2`}
                                </Text>
                            </VStack>
                        </VStack>
                    </PromoVideoPopup>
                }
            </VStack>
        </PopoverModalWrapper>
    );
}
